import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useUserStrategies } from '../../context/UserStrategies';

import { useModalContext } from '../../context/Modal';

import { Loading } from '../UI';
import { WorkspacesProvider } from '../../context/Workspaces';

import { Workspace } from '../Widget';
import { logger } from '../../helpers/logger';
import { ConnectionTypeEnum } from '../../constants/enums';
import { UpsertAsset } from '../Asset/UpsertAsset';

export const StrategyDetail = () => {
  const { t } = useTranslation();
  let { id: strategyId } = useParams();
  const { state } = useLocation();

  const { dispatch: dispatchModal } = useModalContext();
  const { strategies } = useUserStrategies();

  const strategy = strategies.find((s) => s.id === strategyId);

  const openAddAssetModal = (walletAccount: string) => {
    dispatchModal({
      element: (
        <UpsertAsset
          walletAccount={walletAccount}
          strategyId={strategyId}
          selectedConnectionType={ConnectionTypeEnum.WALLET}
          action={'CREATE'}
        />
      ),
      title: t('strategies.newStrategy.addAsset'),
      z: 70,
    });
  };

  useEffect(() => {
    logger.log('StrategyDetail', { state });
    if (state?.account && strategyId) {
      openAddAssetModal(state.account);

      window.history.replaceState({}, document.title);
    }
  }, [state?.account]);

  return (
    <>
      {strategy ? (
        <WorkspacesProvider workspaceId={strategy.workspaceId}>
          <Workspace
            category="TRACKING"
            pageTitle={strategy.name}
            strategyId={strategy.id}
            workspaceId={strategy.workspaceId}
          />
        </WorkspacesProvider>
      ) : (
        <Loading status={true} />
      )}
    </>
  );
};

export default StrategyDetail;
